export default "__VITE_ASSET__CjiSUt8B__"